import instance from '../instance';

const getStaticDocument = () => instance.driver.getStaticDocument();

export default getStaticDocument;
